import { Bar, BarChart, CartesianGrid, Cell, LabelList, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import EmptyState from '../ui/EmptyState';
import { CHART_COLORS, ordinalRamp } from '../../utils/chartColors';

function FunnelTooltip({ active, payload }) {
  if (!active || !payload?.length) return null;
  const { title, count, pctOfFirst } = payload[0].payload;
  return (
    <div className="rounded-xl border border-gray-100 bg-white px-3 py-2.5 shadow-lg">
      <p className="text-xs font-medium text-gray-400">{title}</p>
      <p className="mt-1 text-sm font-semibold text-gray-900">
        {count.toLocaleString()} <span className="font-normal text-gray-400">&middot; {pctOfFirst}% of total</span>
      </p>
    </div>
  );
}

export default function PipelineFunnel({ steps }) {
  if (!steps || steps.length === 0) {
    return <EmptyState title="No candidates currently in this pipeline." />;
  }

  const first = steps[0].count || 1;
  const data = steps.map((s) => ({ ...s, pctOfFirst: Math.round((s.count / first) * 100) }));
  const colors = ordinalRamp(data.length);
  const height = Math.max(220, data.length * 34);

  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={data} layout="vertical" margin={{ left: 24, right: 40 }} barCategoryGap="30%">
        <CartesianGrid strokeDasharray="0" horizontal={false} stroke={CHART_COLORS.grid} />
        <XAxis type="number" allowDecimals={false} tick={{ fill: CHART_COLORS.axis, fontSize: 12 }} axisLine={false} tickLine={false} />
        <YAxis
          type="category"
          dataKey="title"
          width={180}
          tick={{ fill: CHART_COLORS.axis, fontSize: 12 }}
          axisLine={false}
          tickLine={false}
        />
        <Tooltip cursor={{ fill: CHART_COLORS.ink }} content={<FunnelTooltip />} />
        <Bar dataKey="count" radius={[0, 4, 4, 0]} maxBarSize={20} activeBar={{ fillOpacity: 0.85 }}>
          {data.map((entry, i) => (
            <Cell key={entry.title} fill={colors[i]} />
          ))}
          <LabelList
            dataKey="count"
            position="right"
            formatter={(v) => v.toLocaleString()}
            style={{ fill: CHART_COLORS.legend, fontSize: 12, fontWeight: 600 }}
          />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
